import React from 'react';
import {Dimmer, DimmerDimmable, Loader} from 'semantic-ui-react';
import css from './LoadingWidget.css';
import {range} from "lodash";

const LoadingScreen = () => {
    return (
        <div>
            <DimmerDimmable className={css.container}>
                <Dimmer active inverted><Loader>Loading</Loader></Dimmer>
                {range(2).map(index =>
                    <div key={index} className={css.body}>
                        <p className={css.large}>&nbsp;</p>
                        <p className={css.short}>&nbsp;</p>
                        <p className={css.medium}>&nbsp;</p>
                        <p className={css.tiny}>&nbsp;</p>
                    </div>
                )}
            </DimmerDimmable>
        </div>
    )
}

export default LoadingScreen;
